import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface GenericConfirmationDialogData {
    message?: string;
    messageContainsHtml?: boolean;
    confirmButton?: Button;
    cancelButton?: Button;
}

export interface Button {
    text?: string;
    type?: string;
    color?: string;
    backgroundColor?: string;
}

@Component({
    selector: 'r1-compass-lib-generic-confirmation-dialog',
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './generic-confirmation-dialog.component.html',
    styleUrl: './generic-confirmation-dialog.component.scss',
})
export class GenericConfirmationDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<GenericConfirmationDialogComponent>>(MatDialogRef);
    data = inject<GenericConfirmationDialogData>(MAT_DIALOG_DATA);

    static DEFAULT_MESSAGE_TEXT =
        'Making this change will reset your configuration. Click "Yes" to confirm, "No" to cancel.';
    static DEFAULT_MESSAGE_CONTAINS_HTML = false;

    static DEFAULT_CONFIRM_BUTTON_TEXT = 'Yes';
    static DEFAULT_CONFIRM_BUTTON_TYPE = 'stroked';
    static DEFAULT_CONFIRM_BUTTON_COLOR = '';
    static DEFAULT_CONFIRM_BUTTON_BACKGROUND_COLOR = '';
    static DEFAULT_CANCEL_BUTTON_TEXT = 'No';
    static DEFAULT_CANCEL_BUTTON_TYPE = 'flat';
    static DEFAULT_CANCEL_BUTTON_COLOR = 'black';
    static DEFAULT_CANCEL_BUTTON_BACKGROUND_COLOR = '';

    static DEFAULT_CONFIRM_BUTTON: Button = {
        text: GenericConfirmationDialogComponent.DEFAULT_CONFIRM_BUTTON_TEXT,
        type: GenericConfirmationDialogComponent.DEFAULT_CONFIRM_BUTTON_TYPE,
        color: GenericConfirmationDialogComponent.DEFAULT_CONFIRM_BUTTON_COLOR,
        backgroundColor: GenericConfirmationDialogComponent.DEFAULT_CONFIRM_BUTTON_BACKGROUND_COLOR,
    };

    static DEFAULT_CANCEL_BUTTON: Button = {
        text: GenericConfirmationDialogComponent.DEFAULT_CANCEL_BUTTON_TEXT,
        type: GenericConfirmationDialogComponent.DEFAULT_CANCEL_BUTTON_TYPE,
        color: GenericConfirmationDialogComponent.DEFAULT_CANCEL_BUTTON_COLOR,
        backgroundColor: GenericConfirmationDialogComponent.DEFAULT_CANCEL_BUTTON_BACKGROUND_COLOR,
    };

    message!: string;
    messageContainsHtml!: boolean;

    confirmButton!: Button;
    cancelButton!: Button;

    ngOnInit() {
        this.confirmButton = {
            ...GenericConfirmationDialogComponent.DEFAULT_CONFIRM_BUTTON,
            ...this.data?.confirmButton,
        };
        this.cancelButton = { ...GenericConfirmationDialogComponent.DEFAULT_CANCEL_BUTTON, ...this.data?.cancelButton };
        this.message = this.data?.message || GenericConfirmationDialogComponent.DEFAULT_MESSAGE_TEXT;
        this.messageContainsHtml =
            this.data?.messageContainsHtml || GenericConfirmationDialogComponent.DEFAULT_MESSAGE_CONTAINS_HTML;
    }

    onClose(confirm: boolean): void {
        this.dialogRef.close(confirm);
    }
}
